(function () {
  let releaseRefreshScheduled = false;
  let globalReleaseDate = null;

  const padTime = (value) => String(value).padStart(2, '0');

  const parseReleaseDate = (section) => {
    const releaseSeconds = Number(section.dataset.releaseSeconds);
    if (Number.isFinite(releaseSeconds)) {
      const parsed = new Date(releaseSeconds * 1000);
      if (parsed && !Number.isNaN(parsed.getTime()) && !globalReleaseDate) {
        globalReleaseDate = parsed;
      }
      return parsed;
    }

    const raw = section.dataset.releaseIso || '';
    if (!raw) return null;

    const trimmed = raw.trim();
    if (!trimmed.length) return null;

    const normalized = /([zZ]|[+-]\d\d:?\d\d)$/.test(trimmed) ? trimmed : `${trimmed}Z`;
    const releaseDate = new Date(normalized);

    if (Number.isNaN(releaseDate.getTime())) {
      return null;
    }

    if (releaseDate && !Number.isNaN(releaseDate.getTime()) && !globalReleaseDate) {
      globalReleaseDate = releaseDate;
    }

    return releaseDate;
  };

  const hydrateGlobalReleaseFromWindow = () => {
    if (globalReleaseDate) return;

    const seconds = Number(window.__comingSoonReleaseSeconds);
    if (Number.isFinite(seconds)) {
      globalReleaseDate = new Date(seconds * 1000);
      return;
    }

    const iso = window.__comingSoonReleaseIso;
    if (iso) {
      const normalized = /([zZ]|[+-]\d\d:?\d\d)$/.test(iso) ? iso : `${iso}Z`;
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        globalReleaseDate = parsed;
      }
    }
  };

  const resolveReleaseDate = (el) => {
    hydrateGlobalReleaseFromWindow();

    const container = el?.closest('[data-release-seconds],[data-release-iso],[data-coming-soon-release],.coming-soon-modal-release');
    const seconds = Number(container?.dataset?.releaseSeconds);
    if (Number.isFinite(seconds)) {
      return new Date(seconds * 1000);
    }

    const iso = container?.dataset?.releaseIso;
    if (iso) {
      const normalized = /([zZ]|[+-]\d\d:?\d\d)$/.test(iso) ? iso : `${iso}Z`;
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
    }

    return globalReleaseDate;
  };

  const keepTriggerVisible = (trigger) => {
    if (!trigger) return null;

    const unhideTrigger = () => {
      trigger.style.removeProperty('display');
      trigger.removeAttribute('hidden');
      trigger.removeAttribute('aria-hidden');
      trigger.classList.remove('coming-soon-hidden');
    };

    unhideTrigger();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'style' || mutation.attributeName === 'hidden' || mutation.attributeName === 'aria-hidden') {
          unhideTrigger();
        }
      });
    });

    observer.observe(trigger, { attributes: true });

    return () => observer.disconnect();
  };

  const revealNotifyActions = (notifyActions) => {
    if (!notifyActions) return;

    const unhide = () => {
      notifyActions.classList.remove('coming-soon-hidden');
      notifyActions.removeAttribute('hidden');

      const trigger = notifyActions.querySelector('.klaviyo-bis-trigger, .klaviyo-coming-soon-trigger');
      keepTriggerVisible(trigger);
    };

    unhide();
    window.requestAnimationFrame(unhide);
  };

  const updateSection = (section, releaseDate, formButtons, notifyActions) => {
    const countdownEl = section.querySelector('[data-countdown-timer]');

    if (!countdownEl || !releaseDate) {
      section.classList.add('coming-soon-hidden');
      if (formButtons) formButtons.classList.remove('coming-soon-hidden');
      if (notifyActions) notifyActions.setAttribute('hidden', 'true');
      return null;
    }

    revealNotifyActions(notifyActions);

    const renderCountdown = () => {
      const difference = releaseDate.getTime() - Date.now();

      if (difference <= 0) {
        section.classList.add('coming-soon-hidden');
        section.setAttribute('hidden', 'true');

        if (formButtons) {
          formButtons.classList.remove('coming-soon-hidden');
        }

        if (notifyActions) {
          notifyActions.classList.add('coming-soon-hidden');
          notifyActions.setAttribute('hidden', 'true');
        }

        document.querySelectorAll('.coming-soon-text').forEach((badge) => {
          badge.classList.add('coming-soon-hidden');
        });

        if (!releaseRefreshScheduled) {
          releaseRefreshScheduled = true;
          window.setTimeout(() => {
            window.location.reload();
          }, 300);
        }

        return false;
      }

      const days = Math.floor(difference / 86_400_000);
      const hours = Math.floor((difference % 86_400_000) / 3_600_000);
      const minutes = Math.floor((difference % 3_600_000) / 60_000);
      const seconds = Math.floor((difference % 60_000) / 1000);

      countdownEl.textContent = `${padTime(days)}d ${padTime(hours)}h ${padTime(minutes)}m ${padTime(seconds)}s`;

      return true;
    };

    renderCountdown();

    let timerId = null;

    const tick = () => {
      const shouldContinue = renderCountdown();

      if (!shouldContinue && timerId) {
        window.clearInterval(timerId);
      }
    };

    timerId = window.setInterval(tick, 1000);

    return timerId;
  };

  document.addEventListener('DOMContentLoaded', () => {
    hydrateGlobalReleaseFromWindow();

    const sections = document.querySelectorAll('[data-coming-soon-release]');

    if (!sections.length) return;

    const formButtonsMap = new Map();
    document.querySelectorAll('[data-coming-soon-form-buttons]').forEach((form) => {
      formButtonsMap.set(form.dataset.comingSoonFormButtons, form);
    });

    const notifyActionsMap = new Map();
    document.querySelectorAll('[data-coming-soon-actions]').forEach((action) => {
      notifyActionsMap.set(action.dataset.comingSoonActions, action);
    });

    document.querySelectorAll('.klaviyo-bis-trigger, .klaviyo-coming-soon-trigger').forEach((trigger) => {
      const updateVariantId = () => {
        const sectionId = trigger.closest('[data-section-id]')?.dataset.sectionId;
        const variantInput = sectionId
          ? document.querySelector(`[data-section-id="${sectionId}"] .product-variant-id`)
          : trigger.closest('form')?.querySelector('.product-variant-id');

        if (variantInput?.value) {
          trigger.dataset.variantId = variantInput.value;
        }
      };

      updateVariantId();
      trigger.addEventListener('click', updateVariantId);
    });

    sections.forEach((section) => {
      const releaseDate = parseReleaseDate(section);
      const formButtons = formButtonsMap.get(section.dataset.sectionId);
      const notifyActions = notifyActionsMap.get(section.dataset.sectionId);

      const timerId = updateSection(section, releaseDate, formButtons, notifyActions);

      if (timerId) {
        section.dataset.timerId = timerId;
      }
    });

    const modalTimers = new WeakMap();
    const teardownTimer = (el) => {
      const timerId = modalTimers.get(el);
      if (timerId) {
        window.clearInterval(timerId);
        modalTimers.delete(el);
      }
    };

    const initModalCountdown = (releaseEl) => {
      if (!releaseEl || modalTimers.has(releaseEl)) return;

      const releaseDate = resolveReleaseDate(releaseEl);

      if (!releaseDate || Number.isNaN(releaseDate.getTime())) return;

      const countdownEl = releaseEl.querySelector(
        '[data-coming-soon-modal-countdown], .coming-soon-modal-countdown, .klaviyo-coming-soon-countdown'
      );
      if (!countdownEl) return;

      const render = () => {
        const diff = releaseDate.getTime() - Date.now();

        if (diff <= 0) {
          countdownEl.textContent = '00d 00h 00m 00s';
          teardownTimer(releaseEl);
          return false;
        }

        const days = Math.floor(diff / 86_400_000);
        const hours = Math.floor((diff % 86_400_000) / 3_600_000);
        const minutes = Math.floor((diff % 3_600_000) / 60_000);
        const seconds = Math.floor((diff % 60_000) / 1000);

        countdownEl.textContent = `${padTime(days)}d ${padTime(hours)}h ${padTime(minutes)}m ${padTime(seconds)}s`;
        return true;
      };

      render();
      const id = window.setInterval(render, 1000);
      modalTimers.set(releaseEl, id);
    };

    const modalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.coming-soon-modal-release')) {
            initModalCountdown(node);
          }
          node.querySelectorAll?.('.coming-soon-modal-release').forEach((el) => initModalCountdown(el));
        });

        mutation.removedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.coming-soon-modal-release')) {
            teardownTimer(node);
          }
          node.querySelectorAll?.('.coming-soon-modal-release').forEach((el) => teardownTimer(el));
        });
      });
    });

    modalObserver.observe(document.body, { childList: true, subtree: true });

    const updateLooseCountdowns = () => {
      const countdowns = document.querySelectorAll(
        '[data-coming-soon-modal-countdown], .coming-soon-modal-countdown, .klaviyo-coming-soon-countdown'
      );

      countdowns.forEach((el) => {
        const releaseDate = resolveReleaseDate(el);

        if (!releaseDate || Number.isNaN(releaseDate.getTime())) {
          return;
        }

        const diff = releaseDate.getTime() - Date.now();
        if (diff <= 0) {
          el.textContent = '00d 00h 00m 00s';
          return;
        }

        const days = Math.floor(diff / 86_400_000);
        const hours = Math.floor((diff % 86_400_000) / 3_600_000);
        const minutes = Math.floor((diff % 3_600_000) / 60_000);
        const seconds = Math.floor((diff % 60_000) / 1000);

        el.textContent = `${padTime(days)}d ${padTime(hours)}h ${padTime(minutes)}m ${padTime(seconds)}s`;
      });
    };

    updateLooseCountdowns();
    window.setInterval(updateLooseCountdowns, 1000);
  });
})();
